export const IconReply = ({ size = 24 }) => (
	<svg
	width={size}
		height={size}
		viewBox={`0 0 ${size} ${size}`}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			transform={`scale(${size / 24})`}
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.0419 16.2503L18.6809 18.65L16.3253 17.9893L15.7246 18.3429C14.6259 18.9895 13.3578 19.3636 12.0001 19.3636C7.93314 19.3636 4.63636 16.0669 4.63636 11.9998C4.63636 7.93317 7.93307 4.63641 12.0001 4.63641C16.0671 4.63641 19.3636 7.93313 19.3636 11.9998C19.3636 13.3339 19.0037 14.5813 18.3792 15.665L18.0419 16.2503ZM16.5545 19.7531C15.2172 20.5402 13.6643 21 12.0001 21C7.02938 21 3 16.9706 3 11.9998C3 7.02939 7.02938 3.00005 12.0001 3.00005C16.9708 3.00005 21 7.02939 21 11.9998C21 13.6335 20.5582 15.1612 19.797 16.482L20.6311 19.6145C20.7941 20.2267 20.2294 20.7839 19.6195 20.6128L16.5545 19.7531Z"
			fill="currentColor"
		/>
	</svg>
);
